// Production
export const contactFlowId = 'ed406a17-e5f5-4a61-a2fc-f5004d39c626'
export const instanceId = 'a351243b-6844-41b0-97d9-934414342d87'
export const apiGatewayEndpoint = 'https://sbrblsycca.execute-api.us-east-1.amazonaws.com/Prod/'
export const contactAttributeAPIGateway = 'https://ja4tyz6qm6.execute-api.us-east-1.amazonaws.com/prod'
export const awsRegion = 'us-east-1'
